var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('option-list',{attrs:{"options":this.components.frame[1],"inputName":'frameFinish',"target":this.results.frame.finish},on:{"target-updated":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }